module.exports = __webpack_public_path__ + "static/media/bk.192c5593.png";